import React from 'react'

const renderField = ({ input, label, type, meta: { touched, error } }) => (
  <div>
    <div>
      <input {...input} placeholder={label} type={type} className="form-control" />
      {touched && error && <span className="validation_message">{error}</span>}
    </div>
  </div>
)

export default renderField